module.exports = __webpack_public_path__ + "img/49.944a506d.png";